<template>
	<div ref="container" :class="{poweredByTCWrapper: poweredByTC}" class="scroll-container" tabindex="0"
	     v-on:keydown.left="scrollLeft"
	     v-on:keydown.right="scrollRight"
	     v-on:keydown.up="scrollUp"
	     v-on:keydown.down="scrollDown"
	     v-on:keydown.tab="shiftTabScroll"
	     @keydown.-="zoomOut"
	     @keyup.187="zoomIn"
	     @keyup.61="zoomIn"
	     @keyup.107="zoomIn"
	     @keydown.91="handleCmd($event)"
	     @keydown.93="handleCmd($event)"
	     @keydown.224="handleCmd($event)"
	>
		<scroll-bar v-if="enableScrollBars" :class="{ show: showScrollBar, active: !!Math.round(maxScrollX), alwaysShow : alwaysShowScroll }"
		            :max="maxScrollX" :thumb-size="xViewPerc" :value="scrollX" mode="horizontal" @change="onScrollChange"
		            @scrollState="handleScrollState">
			<template #thumb-content>
				<slot name="scroll-thumb-x"/>
			</template>
		</scroll-bar>
		<scroll-bar v-if="enableScrollBars" :class="{ show: showScrollBar, active: !!Math.round(maxScrollY), alwaysShow : alwaysShowScroll }" :max="maxScrollY"
		            :thumb-size="yViewPErc" :value="scrollY" mode="vertical" @change="onScrollChange"
		            @scrollState="handleScrollState">
			<template #thumb-content>
				<slot name="scroll-thumb-y"/>
			</template>
		</scroll-bar>

		<button type="button" ref="leftArrow" v-show="leftArrowVisible && enableScrollButtons" :class="{ 'arrow horizontal left': true, transparency: hasTransparentNavArrows }"
		      :aria-label="prevArrowLabel"
		      @click="scrollLeft"></button>
		<button type="button" ref="rightArrow" v-show="rightArrowVisible && enableScrollButtons" :class="{ 'arrow horizontal right': true, transparency: hasTransparentNavArrows }"
		      :aria-label="nextArrowLabel"
		      @click="scrollRight"></button>

		<div ref="touchLayer" :class="isScrolling? 'scrolling':''" class="touch-layer">
			<div ref="content" class="scroll-item">
				<slot/>
			</div>

		</div>

		<button type="button" ref="nextFlyerArrow" v-if="language === 'en'" v-show="nextFlyerArrowHVisible && enableScrollButtons" :class="{ 'arrow horizontal next-flyer': true, transparency: hasTransparentNavArrows }"
		      aria-label="View next flyer"
		      @click="scrollToHNextFlyer"></button>
		<button type="button" ref="nextFlyerArrow" v-else v-show="nextFlyerArrowHVisible && enableScrollButtons" :class="{ 'arrow horizontal next-flyer-fr': true, transparency: hasTransparentNavArrows }"
		      aria-label="Voir la circulaire suivante"
		      @click="scrollToHNextFlyer"></button>

		<span :class="{ 'arrow vertical up': true, 'is-visible': upArrowVisible && enableScrollButtons && !hideVerticalScroll, transparency: hasTransparentNavArrows }"
		      @click="scrollUp"></span>
		<span :class="{ 'arrow vertical down': true, 'is-visible': downArrowVisible && enableScrollButtons && !hideVerticalScroll, transparency: hasTransparentNavArrows }"
		      @click="scrollDown"></span>
	<button type="button" v-if="language === 'en'" :class="{ 'next-flyer-v': true, 'is-visible': nextFlyerArrowVeVisible && (enableScrollButtons || displayMode === 'mobile'), transparency: hasTransparentNavArrows, mobile: displayMode === 'mobile' }"
		      aria-label="View next flyer"
		      @click="scrollToVNextFlyer"></button>
		<button type="button" v-else :class="{ 'next-flyer-v-fr': true, 'is-visible': nextFlyerArrowVeVisible && (enableScrollButtons || displayMode === 'mobile'), transparency: hasTransparentNavArrows, mobile: displayMode === 'mobile' }"
		      aria-label="Voir la circulaire suivante"
		      @click="scrollToVNextFlyer"></button>

		<!-- <div v-if="scrollToTopVisible && enableScrollToTopButton" class="toTheTop" @click="scrollToTop"/> -->
		<span v-if="this.language === 'en'">
      <transition name="scroll-top-btn">
        <div v-if="scrollToTopVisible && enableScrollToTopButton" class="toTheTop" :class="{ 'scrollbar-visible': showScrollBar }" @click="scrollToTop"/>
      </transition>
    </span>
		<span v-else>
      <transition name="scroll-top-btn">
        <div v-if="scrollToTopVisible && enableScrollToTopButton" class="toTheTopFr" :class="{ 'scrollbar-visible': showScrollBar }" @click="scrollToTop"/>
      </transition>
    </span>
		<PoweredByTC v-if=" poweredByTCVisible"/>
 <!-- Screen reader announcement -->
    <div
      class="page-announcer"
  role="status"
  aria-live="assertive"
  aria-atomic="true"
    >
     <span :key="currentPageNumber">
    {{ liveAnnouncement }}
  </span>
    </div>
	</div>
</template>

<script>

import ScrollContentObserverMixin from "@/components/scroll-container/ScrollContentObserverMixin";

const mounted = [];
const nextFlyerImpressionsSent = new Set();

import ScrollZoom from "@/classes/ScrollZoom";
import ScrollBar from "@/components/scroll-container/ScrollBar";
import Rest from "@/api/Rest";
import PoweredByTC from "@/components/buttons/PoweredByTC.vue"
import {mapActions, mapGetters, mapState} from "vuex";
import Lytics from "../../classes/Lytics";
import {appDict} from "@/features/FeatureHelper";

export default {
	name: "ScrollContainer",
	components: {ScrollBar, PoweredByTC},
	mixins: [ScrollContentObserverMixin],
	props: {
		orientation: {
			type: String,
			default: () => {
				return 'horizontal'
			}
		},
		maxWidth: {
			type: Number,
			default: () => {
				return 900
			}
		},
		align: {
			type: String,
			default: () => {
				return 'center'
			}
		},
		zoomLevel: {
			type: Number,
			default: () => {
				return 0;
			}
		},
		syncGlobalZoom: {
			type: Boolean,
			default: true
		},
		scale: {
			type: [Number, String],
			default: null
		},
		fitAxis: {
			type: String,
			default: () => {
				return null;
			}
		},
		enableScrollBars: {
			type: Boolean,
			default: true
		},
		enableScrollButtons: {
			type: Boolean,
			default: true
		},
		enableScrollToTopButton: {
			type: Boolean,
			default: true
		},
		scrollBarAutoSize: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			maxScrollX: 0,
			maxScrollY: 0,
			scrollX: 0,
			scrollY: 0,
			isScrolling: false,
			showScrollBar: false,
			contentHeight: 0,
			contentWidth: 0,
			viewHeight: 0,
			viewWidth: 0,
			tid: null,
			timeout: null,
			tabDirection: 1,
			liveAnnouncement: ""
		}
	},
	mounted() {
		mounted.push(this);

		this._pendingPageIndex = null;
		this._pendingArrowFocus = null;

		this._sz = new ScrollZoom(this);
		this._sz.fitAxis = this.fitAxis;
		this._sz.zoom = this.zoomLevel;
		this._sz.maxWidth = this.maxWidth;
		this._sz.align = this.align;

		this.contentHeight = this._sz.content.offsetHeight;
		this.contentWidth = this._sz.content.offsetWidth;

		this.viewHeight = this._sz.getViewHeight();
		this.viewWidth = this._sz.getViewWidth();

		this.$refs.content.addEventListener('transitionend', (e) => {

			if (e.target == this.$refs.content) {
				this.$emit('change', this);
			}

		})

		this._sz.update();
		//this.updateScale(this._sz.getScale());

		//This part is added for maintain arrow position while moving by Tab
		this.$refs.container.addEventListener('scroll', () => {
			const isSearch = this.showSearchResults;
			const isVertical = this.flyerOrientation === 'vertical';
		
			const nextPageIndex = this.currentPageIndex + (this.tabDirection === -1 ? -1 : 1);
			if (isVertical) {
				if (!isSearch) {
					this.$root.$emit('trigger-scroll-to-index', nextPageIndex);
					this.$refs.container.scrollTop = 0;
				} else {
					this.scroll({'+y': -300});
					this.$refs.container.scrollTop = 0;
				}
			} else {
				if (!isSearch) {
					this.$root.$emit('trigger-scroll-to-index', nextPageIndex);
					this.$refs.container.scrollLeft = 0;

					
					if (this.enableScrollButtons && this.isFocusInPages()) {
						const pageEl = document.activeElement.closest('[index]');
						if (pageEl) {
							this._pendingPageIndex = Number(pageEl.getAttribute('index'));
						}
						this.focusArrow('leftArrow');
					}
				} else {
					this.scroll({'+x': -300});
					this.$refs.container.scrollLeft = 0;
				}
			}
		});


		setTimeout(() => {
			this.scroll({y: 0, x: 0});
			this.$emit('ready', this);
		}, 10)


		//console.log('Mounted ScrollContainers:', mounted);
	},

	beforeDestroy() {
		const index = mounted.findIndex((item) => {
			return item._uid == this._uid
		})
		if (index >= 0) {
			mounted.splice(index, 1)
		}

		clearTimeout(this._pendingArrowFocusTimeout);
		this._sz.destroy();
		//console.log('UnMounted ScrollContainers:', mounted);
	},

	methods: {
		...mapActions('scale', ['zoomIn', 'zoomOut', 'updateScale', 'setZoomLevel', 'setScrollY', 'updateScrollX', 'setManualZoom']),
		...mapActions('screen', ['handleWindowResize']),
		...mapActions(['setCurrentPageIndex']),
		...mapActions('inlineDrawers', ['openFlyer']),
		...mapActions('drawer', ['openSingleInDrawer']),

		getFocusableTouchElements(pageIndex) {
			if (!this.$refs.content) return [];

			const pageEl = this.$refs.content.querySelector(`[index="${pageIndex}"]`);
			if (!pageEl) return [];

			const selector = [
				'a[href]',
				'button:not([disabled])',
				'input:not([disabled])',
				'select:not([disabled])',
				'textarea:not([disabled])',
				'[tabindex]:not([tabindex="-1"])'
			].join(',');

			return Array.from(pageEl.querySelectorAll(selector)).filter(el => {
				return el.offsetParent !== null && el.getAttribute('aria-hidden') !== 'true';
			});
		},

		// Focus the first product of the page the arrows navigated to (or the current page
		// if we got here by scrolling). Returns true when focus was moved.
		focusFirstItemOfPage(e) {
			let pageIndex = this._pendingPageIndex;
			if (pageIndex == null) {
				const {pages, currentPos} = this.getCurrentPagePosition();
				pageIndex = pages[currentPos]?.index;
			}
			if (pageIndex == null) return false;

			const firstItem = this.getFocusableTouchElements(pageIndex)[0];
			if (!firstItem) return false;

			e.preventDefault();
			firstItem.focus();
			return true;
		},

		shiftTabScroll(e) {
			this.tabDirection = e.shiftKey ? -1 : 1;

			const focused = document.activeElement;
			const nextFlyerArrow = this.$refs.nextFlyerArrow;
			const nextFlyerShown = this.nextFlyerArrowHVisible && this.enableScrollButtons;

			// Last page: the right arrow is hidden, so Tab off the left arrow would fall into page 1.
			// Send it to the next-flyer arrow instead, or straight into the last page's products.
			if (!e.shiftKey && focused === this.$refs.leftArrow && !this.rightArrowVisible) {
				if (nextFlyerShown && nextFlyerArrow) {
					e.preventDefault();
					nextFlyerArrow.focus();
					return;
				}
				if (this.focusFirstItemOfPage(e)) return;
			}

			if (focused && focused === nextFlyerArrow) {
				// Shift+Tab off the next-flyer arrow goes back to the left arrow
				if (e.shiftKey) {
					if (this.leftArrowVisible && this.$refs.leftArrow) {
						e.preventDefault();
						this.$refs.leftArrow.focus();
						return;
					}
				} else if (this.focusFirstItemOfPage(e)) {
					// Forward Tab off the next-flyer arrow goes into the last page's products
					return;
				}
			}

			// Forward Tab off the right arrow
			if (!e.shiftKey && document.activeElement === this.$refs.rightArrow && this._pendingPageIndex != null) {
				const firstItem = this.getFocusableTouchElements(this._pendingPageIndex)[0];
				if (firstItem) {
					e.preventDefault();
					firstItem.focus();
					return;
				}
			}

			if (this.tabDirection === -1) { // only for Shift+Tab
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						const focused = document.activeElement;
						const container = this.$refs.touchLayer;
						if (!focused || !container || !container.contains(focused)) return;
						const f = focused.getBoundingClientRect();
						const c = container.getBoundingClientRect();
						const isVertical = this.flyerOrientation === 'vertical';
						let dx = 0, dy = 0;
						if (isVertical) {
							if (f.top < c.top) dy = f.top - c.top;
							else if (f.bottom > c.bottom) dy = f.bottom - c.bottom;
							const maxStep = 320; // tweak
							dy = Math.max(-maxStep, Math.min(maxStep, dy));
						} else {
							// horizontal
							if (f.left < c.left) dx = f.left - c.left;
							else if (f.right > c.right) dx = f.right - c.right;
						}
						if (dx !== 0 || dy !== 0) {
							this._sz.transform.x -= dx;
							this._sz.transform.y -= dy;
							this._sz.applyTransform();
							this.$refs.container.scrollLeft = 0;
							this.$refs.container.scrollTop = 0;
						}
					});
				});
			}
		},

		handleCmd(e) {
			console.log("called handleCmd, you presed", e.keyCode);
			if (e.keyCode == 187 && e.metaKey) {
				console.log("pressed command + key on mac", e.keyCode);
				this.zoomIn();
			} else if ((e.keyCode == 189 && e.metaKey)) {
				console.log("pressed command - key on mac", e.keyCode);
				this.zoomOut();
			}
		},

		onChange(scroller, events) {
			//console.log('ScrollContainer Event:', scroller)
			this.maxScrollX = scroller.getScrollMaxX();
			this.maxScrollY = scroller.getScrollMaxY();
			this.scrollX = scroller.getScrollX();
			this.scrollY = scroller.getScrollY();

			this.contentHeight = this._sz.content.offsetHeight;
			this.contentWidth = this._sz.content.offsetWidth;

			this.viewHeight = this._sz.getViewHeight();
			this.viewWidth = this._sz.getViewWidth();

			if (events.touchstart) {
				this.isScrolling = true;
			}

			if (this.isScrolling) {
				delete events.resize;
			}

			if (events.touchend) {
				this.isScrolling = false;
			}

			if (events.wheelScroll) {
				// const e = events.wheelScroll;
				// const pr = window.devicePixelRatio;
				// console.log((Math.abs(e.deltaX) > pr) || (Math.abs(e.deltaY) > pr))
				// console.log('Wheel Scroll:', events.wheelScroll);
				// this.isScrolling = (Math.abs(e.deltaX) > pr) || (Math.abs(e.deltaY) > pr);
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.isScrolling = false;
				}, 250);
				this.isScrolling = true;
			}

			if (events.momentum) {
				this.isScrolling = true;
			}


			this.$emit('change', this);

			for (let p in events) {
				this.$emit(p, this);
				switch (p) {
					case 'resize': {
						const screenWidth = window.innerWidth;
						const zoomFactor = Math.pow(screenWidth / 1920, 10)
						const calculatedZoom = Math.max(0, Math.min(0.25, zoomFactor * 0.25));
						if (!this.manualZoom) {
							if (this.flyerOrientation === 'vertical' && this.displayMode === 'desktop' && this.flyerDrawer) {
								this.setZoomLevel(calculatedZoom);
							}
						}
						//TODO - Investigate why this was needed, (removed to see what breaks)
						//this.handleWindowResize();
						break;
					}
					case 'zoom':
						//this.setZoomLevel(this._sz.zoom);
						break;
					case 'pinchend':
						// console.log('Pinch End Updating Scale')
						if (this.syncGlobalZoom) this.setZoomLevel(this._sz.zoom);
						this._sz.zoom = this.zoomLevel;
						this._sz.update();
						this.updateScale(this._sz.getScale());
						this.updateScrollX(this._sz.getScrollX());
						break;
					case 'touchend':
						if (this.displayMode === 'desktop') {
							if (this.syncGlobalZoom) this.setZoomLevel(this._sz.zoom);
						}
						break;
				}
			}
			this.showScrollBar = true;
			clearTimeout(this.scrollBarTimeoutID);
			this.scrollBarTimeoutID = setTimeout(() => {
				this.showScrollBar = false;
			}, 500);

			if (!this.additionalItemInputFocus && !this.emailInputFocus && !this.showSideBar) {
				// this.focus();
			}

			//console.log('maxScrollY:', this.maxScrollY, '   scrollY:', this.scrollY)

		},

		onScrollContainerZoom(scroller) {
			if (this.syncGlobalZoom) this.setZoomLevel(scroller.zoom);
		},

		onScrollChange(delta) {
			//console.log('onScrollChange Delta:', delta);
			this._sz.applyTransform(delta);
		},

		eventScroll(scroll, e) {
			if (e.key === 'ArrowDown' && this.scrollY !== 0) {
				this.setScrollY(this.scrollY)
			}

			const prevent = () => {
				e.stopPropagation();
				e.preventDefault();
				e.returnValue = false;
				return false;
			}
			this.scroll(scroll);
			if (this.scrollY != 0 && this.scrollY != this.maxScrollY) {
				return prevent();
			}
		},

		scroll(scroll) {
			this._sz.velocity = null;
			this.isScrolling = false;
			this._sz.applyTransform(scroll);
		},
		getScroll() {
			return {x: this._sz.getScrollX(), y: this._sz.getScrollY()};
		},
		getController() {
			return this._sz;
		},
		getMaxScroll() {
			return {x: this._sz.getScrollMaxX(), y: this._sz.getScrollMaxY()};
		},

		handleScrollState(state) {
			//console.log('handleScrollState:', state)
			this._sz.enabled = !state;
			this.isScrolling = state;
			this.$emit('scrollState', state);

			//this.$refs.container.focus();

		},

		// Pages are jumped to so their left edge lands at containerLeft + 50
		// (see scrollToDomCenter in App.vue - it left-aligns with a 50px inset,
		// it doesn't center). Anchoring detection to that same point - rather
		// than to "does this page still overflow the viewport edge" - means a
		// half-page ad that's already fully visible isn't skipped over (e.g.
		// page 5 -> 7, dropping the half-page ad at 6).
		getCurrentPagePosition() {
			const container = this.$refs.container;
			const content = this.$refs.content;

			if (!container || !content) {
				return {
					pages: [],
					currentPos: 0
				};
			}

			const pages = Array.from(
				content.querySelectorAll('[index]')
			)
				.map(el => ({
					index: Number(el.getAttribute('index')),
					rect: el.getBoundingClientRect()
				}))
				.filter(page => !Number.isNaN(page.index))
				.sort((a, b) => a.rect.left - b.rect.left);

			// At the scroll boundaries the last (or first) page can't be dragged all the
			// way to the anchor point below - there's nothing left to scroll past it -
			// so the anchor check falls short and resolves to its neighbour instead.
			// Since the boundary is unambiguous, pick the edge page directly there.
			if (this.scrollX <= 0) {
				return {pages, currentPos: 0};
			}
			if (this.scrollX >= this.maxScrollX - 1) {
				return {pages, currentPos: pages.length - 1};
			}

			const containerRect = container.getBoundingClientRect();
			const anchor = containerRect.left + 50;

			let currentPos = 0;

			pages.forEach((page, position) => {
				if (page.rect.left <= anchor + 2) {
					currentPos = position;
				}
			});

			return {
				pages,
				currentPos
			};
		},

		// Position of the page to jump back to. jumping there is clamped by
		// maxScrollX and does nothing, so the left arrow looks stuck. In that case
		// keep stepping back until a page actually requires scrolling left.
		getPreviousPagePos(pages, currentPos) {
			let pos = currentPos - 1;

			if (this.scrollX < this.maxScrollX - 1 || !this.$refs.container) {
				return pos;
			}

			const anchor = this.$refs.container.getBoundingClientRect().left + 50;
			while (pos > 0 && pages[pos].rect.left > anchor + 2) {
				pos--;
			}

			return pos;
		},

		//Focus the arrow when it becomes visible after the page change
		focusArrow(refName) {
			const arrow = this.$refs[refName];
			if (!arrow) return;

			this._pendingArrowFocus = null;
			arrow.focus();
			if (document.activeElement === arrow) return;

			this._pendingArrowFocus = {refName, focusedBefore: document.activeElement};
			//  never let a stale request steal focus on some later,
			// unrelated scroll.
			clearTimeout(this._pendingArrowFocusTimeout);
			this._pendingArrowFocusTimeout = setTimeout(() => {
				this._pendingArrowFocus = null;
			}, 1000);
		},

		completePendingArrowFocus(refName) {
			const pending = this._pendingArrowFocus;
			if (!pending || pending.refName !== refName) return;

			// Wait for the render where v-show reveals the arrow.
			this.$nextTick(() => {
				if (this._pendingArrowFocus !== pending) return;
				this._pendingArrowFocus = null;

				const focused = document.activeElement;
				// Restore focus if the user hasn’t moved on, including when focus falls back to <body>.
				const userMovedOn = focused && focused !== pending.focusedBefore && focused !== document.body;
				if (!userMovedOn) {
					this.$refs[refName]?.focus();
				}
			});
		},

		isFocusInPages() {
			const focused = document.activeElement;
			return !!(focused && this.$refs.touchLayer?.contains(focused));
		},

		// After an arrow jump, send Tab into the new page and move product focus there.
		moveFocusToPage(pageIndex, focusWasInPage) {
			this._pendingPageIndex = pageIndex;
			if (!focusWasInPage) return;

			const firstItem = this.getFocusableTouchElements(pageIndex)[0];
			if (firstItem) {
				
				firstItem.focus({preventScroll: true});
			}
		},

		scrollLeft() {
			const focusWasInPage = this.isFocusInPages();

			// Focus the right arrow after going back, unless focus is moving to a product.
			if (!focusWasInPage) {
				this.focusArrow('rightArrow');
			}

			Lytics.TriggerScrollButtonClick({
				orientation: 'horizontal',
				page_number: this.currentPageNumber,
				scroll_direction: 'backward'
			});

			if (this.features.scroll?.isFullPageScroll && !this.showSearchResults) {
				this.$nextTick(() => {
					const {pages, currentPos} = this.getCurrentPagePosition();
					const previousPage = pages[this.getPreviousPagePos(pages, currentPos)];

					if (!previousPage) {
						this.scroll({x: 0});
						if (pages[0]) {
							this.moveFocusToPage(pages[0].index, focusWasInPage);
						}
						return;
					}

					this.$root.$emit('trigger-scroll-to-index', previousPage.index);
					this.moveFocusToPage(previousPage.index, focusWasInPage);
				});

				return;
			}

			this.scroll({'+x': 300});
		},
		scrollRight() {
			const focusWasInPage = this.isFocusInPages();

			
			if (!focusWasInPage) {
				this.focusArrow('leftArrow');
			}

			Lytics.TriggerScrollButtonClick({
				orientation: 'horizontal',
				page_number: this.currentPageNumber,
				scroll_direction: 'forward'
			})

			if (this.features.scroll?.isFullPageScroll && !this.showSearchResults) {
				this.$nextTick(() => {
					const {pages, currentPos} = this.getCurrentPagePosition();
					const nextPage = pages[currentPos + 1];

					if (!nextPage) {
						return;
					}

					this.$root.$emit('trigger-scroll-to-index', nextPage.index);
					this.moveFocusToPage(nextPage.index, focusWasInPage);

				});

				return;
			}

			this.scroll({'+x': -300});
		},
		scrollToHNextFlyer()
		{

			
			const allflyers=this.sortedFlyers;
			const currentFlyerIndex=allflyers.findIndex(i=>i.flyerId==this.currentFlyer?.flyerId);
  			const nextFlyerIndex = allflyers[(currentFlyerIndex + 1) % allflyers.length];
			
			Lytics.TriggerNextFlyerArrowClick({
				orientation: 'horizontal',
				current_flyer_id: this.currentFlyer?.id,
				current_flyer_position: this.sortedFlyers.findIndex(f => f.flyerId === this.currentFlyer?.flyerId),
				destination_flyer_id: nextFlyerIndex.id,
				is_wraparound:currentFlyerIndex +1 === allflyers.length - 1,
				destination_flyer_is_preview:nextFlyerIndex.flyerType === 'preview',
				total_flyers_in_drawer:allflyers.length,
				
				
			})
			
			this.closeFilterDrawer();
			Rest.NavigateToFlyer(nextFlyerIndex.title).catch((err) => {
				//catch any issue if happened
				console.error('Failed to navigate to next flyer:', err);
			});
		},

		// if sort & filter drawer is open, swap it back to the inline flyer selector
		closeFilterDrawer() {
			if (!this.isFilterOpen) return;
			this.openSingleInDrawer({id: 'flyerSelector', component: appDict.inlineFlyerSelector, drawer: 'left', attrs: {autofocus: false}});
			this.openFlyer();
		},

		scrollToVNextFlyer()
		{
			const allflyers=this.sortedFlyers;
			const currentFlyerIndex=allflyers.findIndex(i=>i.flyerId==this.currentFlyer?.flyerId);
  			const nextFlyerIndex = allflyers[(currentFlyerIndex + 1) % allflyers.length];
			
			Lytics.TriggerNextFlyerArrowClick({
				orientation: 'vertical',
				current_flyer_id: this.currentFlyer?.id,
				current_flyer_position: this.sortedFlyers.findIndex(f => f.flyerId === this.currentFlyer?.flyerId),
				destination_flyer_id: nextFlyerIndex.id,
				is_wraparound:currentFlyerIndex +1 === allflyers.length - 1,
				destination_flyer_is_preview:nextFlyerIndex.flyerType === 'preview',
				total_flyers_in_drawer:allflyers.length,
				
				
			})
			this.closeFilterDrawer();
			Rest.NavigateToFlyer(nextFlyerIndex.title).catch((err) => {
				//catch any issue if happened
				console.error('Failed to navigate to next flyer:', err);
			});
		},

		// Sends the "next flyer" arrow impression once the user reaches the last page (arrow visible)
		// AND currentFlyer has settled to the flyer the URL actually points at
		TrackNextFlyerArrowImpression() {
			if (!this.nextFlyerArrowVisible || !this.flyerIsScrollable) return;

			const flyerTitle  = this.currentFlyer?.title;
			if (!flyerTitle  || flyerTitle  !== this.$route.params.flyerId) return;

			if (nextFlyerImpressionsSent.has(flyerTitle )) return;
			nextFlyerImpressionsSent.add(flyerTitle );

			Lytics.TriggerNextFlyerArrowImpression({
				current_flyer_id:  this.currentFlyer.flyerId,
				current_flyer_position: this.sortedFlyers.findIndex(f => f.flyerId ===  this.currentFlyer.flyerId),
				total_flyers_in_drawer: this.sortedFlyers.length
			});
		},

		scrollUp() {
			if (this.features.scroll?.isFullPageScroll) {
				this.scroll({'+y': 550});
			} else {
				this.scroll({'+y': 300});
			}
			Lytics.TriggerScrollButtonClick({
				orientation: 'vertical',
				page_number: this.currentPageNumber,
				scroll_direction: 'backward'
			})
		},

		scrollDown() {
			if (this.features.scroll?.isFullPageScroll) {
				this.scroll({'+y': -550});
			} else {
				this.scroll({'+y': -300});
			}

			this.setScrollY(this.scrollY + 250)
			Lytics.TriggerScrollButtonClick({
				orientation: 'vertical',
				page_number: this.currentPageNumber,
				scroll_direction: 'forward'
			})
		},


		scrollToTop() {
			this.scroll({y: 0});
		},

		focus() {
			this.$refs.container.focus();
			// console.log('flyer focussed')
		},

		getContainerDom() {
			return this.$refs.container;
		}


	},
	computed: {
		//...mapState('scale', ['zoomLevel']),
		...mapState('scale', ['zoomMin', 'zoomMax', 'manualZoom', 'curentScale']),
		...mapState(['searchInputFocused', 'showSideBar', 'currentPageNumber', 'currentPageIndex']),
		...mapState('shoppingList', ['additionalItemInputFocus', 'emailInputFocus']),
		...mapState(['columnView', 'currentStore', 'pdf']),
		...mapGetters(['language','isCTC']),
		...mapGetters('search', ['showSearchResults']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('config', ['branding', 'features', "rootStyle"]),
		...mapGetters('landingPage', ['sortedFlyers','currentFlyer']),
		...mapGetters('inlineDrawers', ['isFilterOpen']),
		...mapState('landingPage', ['flyerId']),
		poweredByTCVisible() {
			let isPoweredByTC = this.features?.poweredByTC?.enabled
			return isPoweredByTC && this.scrollY >= this.maxScrollY - 5 && this.flyerOrientation == 'vertical'
		},
		poweredByTC() {
			let isPoweredByTC = this.features?.poweredByTC?.enabled
			return isPoweredByTC && this.flyerOrientation == 'vertical'
		},
		alwaysShowScroll() {
			return this.features?.scroll?.alwaysShowScroll ?? false;
		},
		hasTransparentNavArrows() {
			return (this.features?.navigationArrows?.transparent) ?? true;
		},

		prevArrowLabel() {
			return this.language === 'fr' ? 'Page précédente' : 'Previous page';
		},

		nextArrowLabel() {
			return this.language === 'fr' ? 'Page suivante' : 'Next page';
		},
		/*fitAxis() {
		  return this.orientation == 'horizontal' ? 'y' : 'x';
		},*/


		leftArrowVisible() {
			this.$root.$emit((this.scrollX === 0 ? 'hide-arrow' : 'show-arrow'), 'left')
			return this.scrollX > 0 && this.maxScrollX;
		},

		rightArrowVisible() {
			this.$root.$emit((this.scrollX < Math.floor(this.maxScrollX) ? 'show-arrow' : 'hide-arrow'), 'right')
			return this.scrollX < Math.floor(this.maxScrollX);
		},

		nextFlyerArrowHVisible() {
			return !this.rightArrowVisible && !this.showSearchResults && this.sortedFlyers.length > 1 && this.isCTC && this.flyerOrientation === 'horizontal';
		},

		// shown on every display mode once the flyer is scrolled to the last page
		nextFlyerArrowVeVisible() {
			return !this.showSearchResults
				&& this.sortedFlyers.length > 1
				&& this.isCTC
				&& this.flyerOrientation === 'vertical'
				&& !this.downArrowVisible
				&& !this.features?.poweredByTC?.enabled;
		},

		nextFlyerArrowVisible() {
			return this.nextFlyerArrowHVisible || this.nextFlyerArrowVeVisible;
		},

		// maxScroll is 0 until the flyer is laid out, so the "at the end" check is only meaningful after that.
		// orientation check skips other scroll containers (e.g. FeatureToast).
		flyerIsScrollable() {
			if (this.orientation !== this.flyerOrientation) return false;
			return this.flyerOrientation === 'horizontal' ? this.maxScrollX > 0 : this.maxScrollY > 0;
		},

		upArrowVisible() {
			this.$root.$emit((this.scrollY === 0 ? 'hide-arrow' : 'show-arrow'), 'up')
			return this.scrollY > (1 / devicePixelRatio);
		},

		downArrowVisible() {
			this.$root.$emit((this.scrollY < Math.ceil(this.maxScrollY - 1) ? 'show-arrow' : 'hide-arrow'), 'down')
			return (this.scrollY < Math.ceil(this.maxScrollY) - 1);
		},

		scrollToTopVisible() {
			return this.scrollY > 0 && this.orientation == 'vertical';
		},

		xViewPerc() {
			return (this.viewWidth / this.contentWidth) * 100;
		},
		yViewPErc() {
			return (this.viewHeight / this.contentHeight) * 100;
		},
		flyerDrawer() {
			return this.features.flyerSelector._flyerOrientation['+vertical']?.['_display']?.['+desktop']?.position === 'left';
		},
		hideVerticalScroll() {
			return this.features?.scroll?.hideVerticalScroll ?? false;
		}

	},

	watch: {
		// Fires once per flyer, when the user scrolls to the last page and the "next flyer" arrow (H or V) shows.
		nextFlyerArrowVisible() {
			this.TrackNextFlyerArrowImpression();
		},
		flyerIsScrollable() {
			this.TrackNextFlyerArrowImpression();
		},
		// covers currentFlyer settling to the routed flyer while the user is already on the last page
		currentFlyer() {
			this.TrackNextFlyerArrowImpression();
		},
		leftArrowVisible(visible) {
			if (visible) this.completePendingArrowFocus('leftArrow');
		},
		rightArrowVisible(visible) {
			if (visible) this.completePendingArrowFocus('rightArrow');
		},
		orientation() {
			this._sz.fitAxis = this.fitAxis;
			if (this.flyerOrientation === 'vertical' && this.displayMode === 'desktop') {
				this.setManualZoom(false)
				this.setZoomLevel(this.zoomLevel)
			} else {
				this.setZoomLevel(0)
			}
			// this.setZoomLevel(this.zoomLevel)
			/*if(val == 'horizontal'){
			  this._sz.setScrollX( -this.scrollY )
			} else {
			  this._sz.setScrollY( -this.scrollX )
			}*/
			this._sz.update();

		},
		displayMode() {
			if (this.displayMode !== 'desktop') {
				this.setZoomLevel(0)
			}
		},
		zoomLevel(val) {
			//console.log('Watch Zoom Level', val)
			this._sz.zoom = val;
			this._sz.update();
			//this.updateScale(this._sz.getScale());
		},
		maxWidth(val) {
			this._sz.maxWidth = val;
			this._sz.update();
		},
		// searchInputFocused(val){
		//   if(!val){
		//     this.focus();
		//   }
		// },
		align(val) {
			this._sz.align = val;
			this._sz.update();
		},
		currentPageNumber(newPage) {
			this.liveAnnouncement = `Flyer page ${newPage}`;
		},
				}

}
</script>

<style scoped>
.scroll-container:focus {
	outline: none;
}

.page-announcer {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}

.scroll-container {
	min-height: 10px;
}

.scroll-container.poweredByTCWrapper {
	padding-bottom: 25px !important;
}

.toTheTop {
	display: block;
	width: 90px;
	height: 90px;
	background: url('/images/back-tothe-top-mobile.png') no-repeat center 45%;
	background-size: 77% auto;
	position: absolute;
  right: 0;
	bottom: 20px;
	cursor: pointer;
	filter: drop-shadow(2px 4px 6px black);
	opacity: 0.9;
	cursor: pointer;
	z-index: 5;
  transition: right 0.3s;
  transition-delay: 2s;
}

.toTheTop.scrollbar-visible {
  right: 15px;
  transition-delay: 0s;
}

.toTheTopFr {
	display: block;
	width: 90px;
	height: 90px;
	background: url('/images/back-tothe-top-mobile-fr-png.png') no-repeat center 45%;
	background-size: 68% auto;
	position: absolute;
  right: 0;
	bottom: 20px;
	cursor: pointer;
	filter: drop-shadow(2px 4px 6px black);
	opacity: 0.9;
	cursor: pointer;
	z-index: 5;
  transition: right 0.3s;
  transition-delay: 2s;
}

.toTheTopFr.scrollbar-visible {
  right: 15px;
  transition-delay: 0s;
}

.scroll-top-btn-enter-active,
.scroll-top-btn-leave-active {
  transition: opacity 0.3s;
}

.scroll-top-btn-enter,
.scroll-top-btn-leave-to {
  opacity: 0;
}

@media screen and (max-width: 628px) {
	.scroll-container.poweredByTCWrapper {
		padding-bottom: 30px !important;
	}

	.arrow {
		display: none !important;
	}

	.scroll-bar.horizontal {
		display: none;
	}
}

@media screen and (min-width: 628px) {

	.toTheTop {
		display: none;
	}

	.toTheTopFr {
		display: none;
	}
}

@media screen and (min-width: 1256px) {
	.toTheTop {
		display: none;
	}

	.toTheTopFr {
		display: none;
	}
}

.arrow {
	position: absolute;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	opacity: 1;
	transition: opacity 200ms, filter 100ms;
	/*box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.5);*/
	filter: drop-shadow(0px 0px 0px #222);
	cursor: pointer;
	display: none;
	/* reset default <button> chrome for the next-flyer button, harmless for the <span> arrows */
	border: none;
	padding: 0;
	background-color: transparent;
	font: inherit;
}

button.arrow {
	display: block;
	border: none;
	background-color: transparent;
	padding: 0;
	font: inherit;
}

.arrow:focus-visible {
	outline: 2px solid #fff;
	outline-offset: 2px;
	box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.6);
}

.arrow.transparency {
	opacity: 0.4 !important;
}

.arrow.is-visible {
	display: block;
}

.arrow.transparency:hover,
.arrow.transparency:focus-visible {
	opacity: 0.9 !important;
	filter: drop-shadow(3px 2px 3px #222);
}

.arrow:active {
	filter: drop-shadow(0px 0px 0px #222);
}

.arrow.horizontal {
	top: 50%;
	transform: translateY(-50%);
}

.arrow.vertical {
	left: 50%;
	transform: translateX(-50%);
	touch-action: none;
}

.arrow.left {
	background-image: url("/images/moveleft-arrow-desktop.png");
	left: 35px;
}

.arrow.right {
	background-image: url("/images/moveright-arrow-desktop.png");
	right: 35px;
}

.arrow.next-flyer {
	background-image: url("/images/movenextH-arrow-desktop.png");
	background-size: 125% 125%;
	right: 0;
}

.arrow.next-flyer-fr {
	background-image: url("/images/movenextH-arrow-desktop-FR.png");
	background-size: 125% 125%;
	right: 0;
}

.next-flyer-v,
.next-flyer-v-fr {
	position: absolute;
	left: 50%;
	bottom: 0px;
	transform: translateX(-50%);
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	border: none;
	padding: 0;
	background-color: transparent;
	cursor: pointer;
	display: none;
	transition: opacity 200ms, filter 100ms;
	filter: drop-shadow(0px 0px 0px #222);
}

.next-flyer-v.is-visible,
.next-flyer-v-fr.is-visible {
	display: block;
}

.next-flyer-v.transparency,
.next-flyer-v-fr.transparency {
	opacity: 0.4;
}

.next-flyer-v.transparency:hover,
.next-flyer-v-fr.transparency:hover,
.next-flyer-v.transparency:focus-visible,
.next-flyer-v-fr.transparency:focus-visible {
	opacity: 0.9;
	filter: drop-shadow(3px 2px 3px #222);
}

/* touch devices have no hover, so darken while the button is pressed too */
.next-flyer-v.transparency:active,
.next-flyer-v-fr.transparency:active {
	opacity: 0.9;
}

.next-flyer-v:active,
.next-flyer-v-fr:active {
	filter: drop-shadow(0px 0px 0px #222);
}

.next-flyer-v {
	background-image: url("/images/movenextV-arrow-desktop.png");
	width: 121px;
	height: 32px;
}

.next-flyer-v-fr {
	background-image: url("/images/movenextV-arrow-desktop-FR.png");
	width: 164px;
	height: 32px;
}

.next-flyer-v.mobile,
.next-flyer-v-fr.mobile {
	background-image: none;
	background-color: #23571f;
	color: #fff;
	width: auto;
	height: 32px;
	padding: 0 12px;
	border-radius: 6px;
	font-size: 13px;
	font-weight: 600;
	white-space: nowrap;
	
	opacity: 0.6;
}

@media (hover: hover) {
	.next-flyer-v.mobile:hover,
	.next-flyer-v-fr.mobile:hover {
		opacity: 1;
		filter: drop-shadow(3px 2px 3px #222);
	}
}

.next-flyer-v.mobile:focus-visible,
.next-flyer-v-fr.mobile:focus-visible,
.next-flyer-v.mobile:active,
.next-flyer-v-fr.mobile:active {
	opacity: 1;
}

.next-flyer-v.mobile.is-visible,
.next-flyer-v-fr.mobile.is-visible {
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.next-flyer-v.mobile::before,
.next-flyer-v-fr.mobile::before {
	content: "»";
	display: inline-block;
	transform: rotate(90deg);
	font-size: 16px;
	line-height: 1;
}

.next-flyer-v.mobile::after {
	content: "View Next Flyer";
}

.next-flyer-v-fr.mobile::after {
	content: "Voir la circulaire suivante";
}

.arrow.up {
	background-image: url("/images/moveleft-arrow-desktop.png");
	transform: rotate(90deg) translateY(-50%);
	transform-origin: top left;
	top: 35px;
}

.arrow.down {
	background-image: url("/images/moveleft-arrow-desktop.png");
	transform: rotate(-90deg) translateY(50%);
	transform-origin: bottom left;
	bottom: 35px;
}

.scroll-container {
	position: relative;
	z-index: 0;
	overflow: hidden;
	width: 100%;
	height: 100%;
}

.scroll-item {
	width: max-content;
	height: max-content;
	transform: translateZ(0px);
	transition: transform 0.3s;
	transform-origin: top left;
}

.scrolling .scroll-item {
	transition: none;
	pointer-events: none;
	touch-action: none;
}

.scroll-container * {
	-webkit-backface-visibility: hidden;
}

.touch-layer {
	position: relative;
	z-index: -1;
	left: 0px;
	right: 0px;
	top: 0px;
	bottom: 0px;
	height: 100%;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
